var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main_container"},[_c('my-title'),_vm._v(" "),_c('h1',{staticClass:"groupName"},[_vm._v(_vm._s(_vm.group.name))]),_vm._v(" "),_c('member-list',{attrs:{"members":_vm.members}}),_vm._v(" "),_c('shop-list',{attrs:{"restaurants":_vm.restaurants}}),_vm._v(" "),_c('start-button'),_vm._v(" "),_c('loading-modal')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0a4b4b17","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/groups/detail.vue
// module id = null
// module chunks = 